<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-fridge`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M39 3a1 1 0 00-1-1H10a1 1 0 00-1 1v42a1 1 0 001 1h28a1 1 0 001-1V3zM13 26h22v16H13V26zM35 6H13v16h22V6zm-15 5a1 1 0 00-1-1h-2a1 1 0 00-1 1v5a1 1 0 001 1h2a1 1 0 001-1v-5z"/></svg>
</template>
<script>

export default {
  name: 'IconFridge',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
